import { render } from "./tabBar.vue?vue&type=template&id=01ca06d3"
import script from "./tabBar.vue?vue&type=script&lang=js"
export * from "./tabBar.vue?vue&type=script&lang=js"

import "./tabBar.vue?vue&type=style&index=0&id=01ca06d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__